"use strict";

exports.__esModule = true;
exports.UserSelector = void 0;
exports.itemPredicate = itemPredicate;
exports.renderItemText = renderItemText;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core/");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.username;
}
function renderItemText(input) {
  return (0, _Utils.formatUserName)(input);
}
function itemPredicate(query, item) {
  if (!item.isEnabled) {
    return false;
  }
  var displayName = (0, _Utils.formatUserName)(item);
  return !!displayName.match(new RegExp((0, _Utils.escapeRegExp)(query), "gi"));
}

/**
 * Allows a user to select plant state(s) from a list.
 */
var UserSelector = exports.UserSelector = (0, _styledComponents.withTheme)(function (props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    itemPredicate: itemPredicate,
    placeholder: translate("UserSelector.placeholder.single", "Select User"),
    getKey: getKey,
    renderItemText: renderItemText,
    popoverProps: {
      usePortal: false
    },
    width: 275
  }, props));
});